<template>
  <div :class="$style.page">
    <Row :class="$style.top_actions">
      <Button type="primary" @click="addAnalysis">添加记录</Button>
      <Button type="primary" @click="batchDelete">批量删除</Button>
    </Row>

    <Loading :loading="loading">
      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="全选" width="30" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
              @change="(v) => handleSelectItem(v, scope.row)"
            />
          </template>
        </el-table-column>

        <el-table-column label="序号" width="30" align="center">
          <template slot-scope="scope">{{
            limit * (page - 1) + scope.$index + 1
          }}</template>
        </el-table-column>

        <el-table-column
          prop="host"
          label="主机记录"
          width="80"
          align="center"
        />

        <el-table-column
          prop="recordType"
          label="记录类型"
          width="80"
          align="center"
        />

        <el-table-column
          prop="recordValue"
          label="记录值"
          width="50"
          align="center"
        />

        <el-table-column
          prop="lineName"
          label="线路类型"
          width="50"
          align="center"
        />

        <el-table-column
          prop="mxValue"
          label="MX优先级"
          width="60"
          align="center"
        />

        <el-table-column prop="ttl" label="TLL" width="60" align="center" />

        <el-table-column
          prop="updatedTime"
          label="更新时间"
          width="80"
          align="center"
        />

        <el-table-column label="状态" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.row.status === 1 ? "正常" : "暂停" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="expireTime"
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="$style.table_actions">
              <Button type="text" @click="clickActions(0, scope.row)">
                修改
              </Button>
              <Button
                v-if="scope.row.status === 2"
                type="text"
                @click="clickActions(1, scope.row)"
              >
                启用
              </Button>
              <Button
                v-if="scope.row.status === 1"
                type="text"
                @click="clickActions(2, scope.row)"
              >
                暂停
              </Button>
              <Button type="text" @click="clickActions(3, scope.row)">
                删除
              </Button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <Row :class="$style.bottom_actions">
        <el-checkbox
          :class="$style.select_all"
          v-model="selectAll"
          :disabled="total === 0"
          @change="handelSelectAll"
        >
          {{ selectAll ? "取消全选" : "全选" }}
        </el-checkbox>

        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="limit"
          :total="total"
          @current-change="handlePageChange"
        />
      </Row>
    </Loading>

    <!-- popup -->
    <EditAnalysisPopup
      :visible="visible"
      :mode="type"
      :domainName="domainName"
      :item="updateItem"
      @confirm="editConform"
      @close="editClose"
    />
  </div>
</template>

<script>
import {
  getResolutionList,
  deleteResolution,
  postResolutionStart,
  postResolutionPause,
  postResolutionSave,
  postResolutionModify,
} from "@server";

import EditAnalysisPopup from "./EditAnalysisPopup.vue";

export default {
  name: "DomainAnalysis",
  components: { EditAnalysisPopup },
  data() {
    return {
      id: "",
      domainName: "",

      loading: false,
      page: 1,
      limit: 10,
      showList: [],
      total: 0,

      selectList: [],
      selectAll: false,

      // 添加、修改解析
      visible: false,
      type: 0, // 0 - 添加， 1 - 修改
      updateItem: {},
    };
  },
  watch: {
    selectList(val) {
      const _total = this.showList.length;
      this.selectAll = _total > 0 && _total === val.length;
    },
  },
  methods: {
    async getResolutionList(page = 1) {
      this.page = page;
      this.loading = true;

      const params = {
        page,
        limit: this.limit,
        id: this.id,
      };
      const res = await getResolutionList(params);
      const { code, data } = res;

      if (code === 200) {
        this.showList = data.list.map((item) => ({ ...item, checked: false }));
        this.total = data.total;
      }
      this.loading = false;
    },

    setVisible(v) {
      this.visible = v;
    },

    addAnalysis() {
      this.type = 0;
      this.setVisible(true);
    },

    async editConform(params) {
      this.loading = true;
      let res = {};
      if (this.type === 0) {
        params.domainId = parseInt(this.id);
        res = await postResolutionSave(params);
      } else {
        params.id = parseInt(this.updateItem.id);
        res = await postResolutionModify(params);
      }

      if (res.code === 200) {
        this.$message({ message: "操作成功", type: "success" });
        this.getResolutionList();
      } else {
        this.$message({ message: res.message, type: "error" });
      }

      this.editClose();
      this.loading = false;
    },

    editClose() {
      this.type = 0;
      this.updateItem = {};
      this.setVisible(false);
    },

    // 处理域名选中
    handelSelectAll(isAll) {
      const _list = this.showList.map((item) => ({ ...item, checked: isAll }));

      this.showList = _list;
      this.selectList = isAll ? _list : [];
    },
    handleSelectItem(isSelect, item) {
      if (isSelect) {
        this.selectList.push(item);
      } else {
        this.selectList = this.selectList.filter((i) => i.id !== item.id);
      }
    },

    clickActions(action, item) {
      switch (action) {
        case 0:
          this.updateAnalysis(item);
          break;
        case 1:
          this.toStart(item.id);
          break;
        case 2:
          this.toPause(item.id);
          break;
        case 3:
          this.submitBatchDelete([item.id]);
          break;
      }
    },

    updateAnalysis(item) {
      this.type = 1;
      this.updateItem = item;
      this.setVisible(true);
    },

    toStart(id) {
      this.$confirm(`您确定开始解析操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await postResolutionStart(id);

          if (res.code === 200) {
            this.$message({ message: "操作成功", type: "success" });
            this.getResolutionList();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    toPause(id) {
      this.$confirm(`您确定暂停解析操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await postResolutionPause(id);

          if (res.code === 200) {
            this.$message({ message: "操作成功", type: "success" });
            this.getResolutionList();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    // 删除操作
    batchDelete() {
      if (this.selectList.length === 0) {
        this.$message({
          message: "请选择域名后再操作批量删除!",
          type: "warning",
        });
        return;
      }

      const recordIds = this.selectList.map((i) => i.id);
      this.submitBatchDelete(recordIds);
    },
    submitBatchDelete(recordIds = []) {
      this.$confirm(`您确定删除解析操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await deleteResolution(recordIds);

          if (res.code === 200) {
            this.$message({ message: "操作成功", type: "success" });
            this.getResolutionList();
          } else {
            this.$message({ message: res.message, type: "error" });
          }

          this.loading = false;
        })
        .catch(() => {});
    },

    handlePageChange(page) {
      this.getResolutionList(page);
    },
  },
  created() {
    const { query } = this.$route;
    this.id = query.id ? query.id : "";
    this.domainName = query.name || "";
    this.getResolutionList();
  },
};
</script>

<style lang='scss' module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  background: $white;
  box-shadow: $box-shadow;

  :global {
    .el-pagination {
      @include flex();
    }
  }

  .top_actions {
    margin-bottom: rem(40);
    gap: rem(50);
  }

  .table_actions {
    @include flex();
    gap: rem(10);

    :global {
      .gl-button {
        color: $theme-color;
      }
    }
  }

  .bottom_actions {
    margin: rem(50) 0 rem(20);
    justify-content: space-between;

    .select_all {
      padding-left: 10px;
    }
  }
}
</style>
